import { useEffect, useState } from 'react';
import BBITable from '../../helpers/bBITable/BBITable';
import React from 'react';
import Get from '../../api/internal/Get';
import FilterData from '../../helpers/filter/FilterData';
import View from '../../helpers/slab/View';
import ViewTruck from '../../features/views/assets/truck/Truck';
import { useOutletContext } from 'react-router-dom';
import { PageLoadingSpinner } from '../../helpers/loadingSpinner/LoadingSpinner';
import DateOnlyFormatter from '../../helpers/inputs/DateOnlyFormatter';
import Header from '../../layouts/Header';
import DownloadCsvButton from '../../helpers/buttons/DownloadCsvButton';

function TruckBoard({ toggleBoardRefresh }) {
  const [trucks, setTrucks] = useState<TruckBoard[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const filterValue = useOutletContext();

  useEffect(() => {
    GetTruckBoard();
  }, [toggleBoardRefresh]);

  function GetTruckBoard() {
    setIsLoading(true);
    Get(`/Asset/GetTruckBoard`)
      .then(response => {
        if (response) {
          setTrucks(response.data);
        }
        setIsLoading(false);
      })
      .finally(() => setIsLoading(false));
  }

  if (isLoading) {
    return <PageLoadingSpinner />;
  }

  function FormatTruckBoard(trucks: TruckBoard[]) {
    return trucks.map(truck => ({
      ...truck,
      weeklyCost:
        truck.weeklyCost?.toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD',
        }) ?? null,
      registrationExpiration: DateOnlyFormatter(truck.registrationExpiration),
      federalInspectionExpiration: DateOnlyFormatter(
        truck.federalInspectionExpiration,
      ),
    }));
  }

  const columnConfig = [
    {
      key: '1',
      attribute: 'truckName',
      attributeprimaryhidden: 'assetId',
      header: 'Truck Unit #',
      onClick: e =>
        View(
          <ViewTruck
            truckName={e.target.innerText}
            assetId={e.target.dataset.attributeprimaryhidden}
          />,
        ),
    },
    {
      key: '2',
      attribute: 'vin',
      header: 'VIN',
    },
    {
      key: '3',
      attribute: 'make',
      header: 'Make',
    },
    {
      key: '4',
      attribute: 'model',
      header: 'Model',
    },
    {
      key: '5',
      attribute: 'year',
      header: 'Year',
    },
    {
      key: '6',
      attribute: 'licensePlateNumber',
      header: 'Plate',
    },
    {
      key: '7',
      attribute: 'licensePlateState',
      header: 'Plate State',
    },
    {
      key: '8',
      attribute: 'ownership',
      header: 'Ownership',
    },
    {
      key: '9',
      attribute: 'truckType',
      header: 'Type',
    },
    {
      key: '10',
      attribute: 'driverName',
      header: 'Driver',
    },
    {
      key: '11',
      attribute: 'weeklyCost',
      header: 'Weekly Cost',
      dataType: 'currency',
    },
    {
      key: '12',
      attribute: 'registrationExpiration',
      header: 'Registration Exp.',
    },
    {
      key: '13',
      attribute: 'federalInspectionExpiration',
      header: 'Federal Inspection Exp.',
    },
  ];

  const tableData = FilterData(trucks, filterValue);

  const csvData = FormatTruckBoard(tableData);

  return (
    <>
      <Header>
        <div>
          <DownloadCsvButton
            data={csvData}
            columnConfig={columnConfig}
            fileName={`Trucks_${new Date().toLocaleDateString()}.csv`}
          />
        </div>
      </Header>
      <BBITable data={csvData} columns={columnConfig} />
    </>
  );
}

export default TruckBoard;
